/* ---------------------------------------------------------------
   Makes the silent looping clips actually play.

   The markup Shopify generates for video_tag carries loading="lazy".
   That is not a real attribute on <video>, and it defers the fetch far
   enough that autoplay never starts. The clips sat on their poster frame
   with readyState 0, on phones and on desktop alike.

   What this does, in order:

   1. Strips loading="lazy" and sets muted and playsInline as PROPERTIES.
      Safari checks the property, not the attribute, when it decides
      whether a video is allowed to start on its own.
   2. Raises preload from metadata to auto, so there is something to play.
   3. Calls play() when the clip comes into view, rather than trusting the
      autoplay attribute, and pauses it again once it leaves. Offscreen
      video is wasted battery and wasted data on a phone.
   4. If play() is refused, shows a tap to play button. iOS in Low Power
      Mode refuses every single time, whatever the markup says, and a dead
      looking clip is worse than one with a button on it.

   Only touches muted autoplay clips. Anything with controls is left alone.
   --------------------------------------------------------------- */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video[autoplay]'));
  if (!vids.length) return;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function prep(v) {
    v.removeAttribute('loading');
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.loop = true;
    if (v.preload !== 'auto') v.preload = 'auto';
  }

  function button(v) {
    var host = v.closest('.aob-ways__pic, .aob-how__media, .aob-pdp__clip, .aob-vid__frame, .aob-pdp__shot') || v.parentElement;
    if (!host) return null;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var existing = host.querySelector('.aob-tapplay');
    if (existing) return existing;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'aob-tapplay';
    b.setAttribute('aria-label', 'Play video');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var p = v.play();
      if (p && p.then) p.then(function () { b.classList.remove('is-on'); });
    });
    host.appendChild(b);
    return b;
  }

  function start(v) {
    if (!v.paused) return;
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        var b = button(v);
        if (b) b.classList.add('is-on');
      });
    }
  }

  vids.forEach(prep);

  // reduce motion means no looping clips start on their own, but they are
  // still playable by hand
  if (still) {
    vids.forEach(function (v) {
      v.removeAttribute('autoplay');
      var b = button(v);
      if (b) b.classList.add('is-on');
    });
    return;
  }

  var queued = false;
  function sweep() {
    queued = false;
    var h = window.innerHeight;
    vids.forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (r.height === 0) return;
      var visible = r.top < h * 0.95 && r.bottom > h * 0.05;
      if (visible) start(v);
      else if (!v.paused) v.pause();
    });
  }
  function onMove() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sweep);
  }

  window.addEventListener('scroll', onMove, { passive: true });
  window.addEventListener('resize', onMove, { passive: true });
  document.addEventListener('visibilitychange', onMove);
  sweep();
  setTimeout(sweep, 600);
  setTimeout(sweep, 2000);
})();
